import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Tooltip, Tag } = require("antd");

const ProblemRideTag = () => {
  return (
    <Tooltip
      color="#fff"
      title="A shipment had an out-of-the-ordinary event such as a wreck, stolen vehicle,
    vehicle mistakenly picked up leading to an unexpected split load, etc."
    >
      <Tag color="warning">
        <InfoCircleOutlined /> Problem Ride
      </Tag>
    </Tooltip>
  );
};

export default ProblemRideTag;
